import { render } from "./asset-header.vue?vue&type=template&id=9d4cc0a6"
import script from "./asset-header.vue?vue&type=script&lang=js"
export * from "./asset-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__